(() => {
  'use strict';

  const BATCH_SIZE = 6;
  const timeMinutes = (value) => {
    const match = String(value || '').trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/);
    if (!match) return Number.MAX_SAFE_INTEGER;
    let hours = Number(match[1]);
    const minutes = Number(match[2] || 0);
    if (match[3] === 'am' && hours === 12) hours = 0;
    if (match[3] === 'pm' && hours < 12) hours += 12;
    return (hours * 60) + minutes;
  };
  const compareCards = (a, b) => {
    const date = (a.dataset.startDate || '').localeCompare(b.dataset.startDate || '');
    if (date) return date;
    const time = timeMinutes(a.dataset.startTime) - timeMinutes(b.dataset.startTime);
    if (time) return time;
    return (a.dataset.title || '').localeCompare(b.dataset.title || '', undefined, { sensitivity: 'base' });
  };

  document.querySelectorAll('[data-bpc-card-events]').forEach((root) => {
    const upcomingGrid = root.querySelector('[data-simple-upcoming-grid]');
    const cards = upcomingGrid ? [...upcomingGrid.querySelectorAll('[data-simple-event-card]')] : [];
    const filter = root.querySelector('[data-simple-event-filter]');
    const filterWrap = filter?.closest('.bpc-card-events__filter');
    const showMore = root.querySelector('[data-simple-show-more]');
    const empty = root.querySelector('[data-simple-upcoming-empty]');
    let visibleCount = BATCH_SIZE;

    cards.sort(compareCards).forEach((card) => upcomingGrid.appendChild(card));

    const updateUpcoming = () => {
      const selected = filter?.value || 'all';
      const matches = cards.filter((card) => selected === 'all' || card.dataset.eventType === selected);
      cards.forEach((card) => { card.hidden = true; });
      matches.slice(0, visibleCount).forEach((card) => { card.hidden = false; });
      if (empty) empty.hidden = matches.length !== 0;
      if (showMore) showMore.hidden = matches.length <= visibleCount;
    };

    if (!cards.length && filterWrap) filterWrap.hidden = true;
    filter?.addEventListener('change', () => {
      visibleCount = BATCH_SIZE;
      updateUpcoming();
    });
    showMore?.addEventListener('click', () => {
      visibleCount += BATCH_SIZE;
      updateUpcoming();
    });
    updateUpcoming();

    const pastSection = root.querySelector('[data-simple-past-section]');
    const pastGrid = root.querySelector('[data-simple-past-grid]');
    const pastCards = pastGrid ? [...pastGrid.querySelectorAll('[data-simple-event-card]')] : [];
    pastCards.sort((a, b) => compareCards(b, a)).forEach((card) => pastGrid.appendChild(card));
    if (pastSection) pastSection.hidden = pastCards.length === 0;
  });
})();
